import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import NewsFeedHeader from './components/NewsFeedHeader';
import ResultsListing from './components/ResultsListing';

import { useParams, useFetch } from './hooks';

const NewsFeed = ({
  endpoint,
  title,
  typeLabel,
  yearLabel,
  noResultsLabel
}) => {
  const anchorRef = useRef();
  const [{ page, type, year }, setPage, setType, setYear] = useParams();
  const { results, loading } = useFetch(endpoint, { page, type, year });

  const {
    feed,
    typeOptions,
    yearOptions,
    resultsCount,
    resultsPerPage
  } = results;

  const handlePaginate = page => {
    setPage(page);

    if (anchorRef?.current) {
      anchorRef?.current.scrollIntoView();
    }
  };

  return (
    <div ref={anchorRef}>
      <NewsFeedHeader
        title={title}
        typeLabel={typeLabel}
        typeOptions={typeOptions}
        typeValue={type}
        onTypeChange={setType}
        yearLabel={yearLabel}
        yearOptions={yearOptions}
        yearValue={year}
        onYearChange={setYear}
      />
      <div className="news-feed__listing">
        {loading && <div className="loading"></div>}
        {!loading && (
          <ResultsListing
            feed={feed}
            page={parseInt(page)}
            resultsCount={resultsCount}
            resultsPerPage={resultsPerPage}
            noResultsLabel={noResultsLabel}
            onPaginate={handlePaginate}
          />
        )}
      </div>
    </div>
  );
};

NewsFeed.propTypes = {
  endpoint: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  typeLabel: PropTypes.string.isRequired,
  yearLabel: PropTypes.string.isRequired,
  noResultsLabel: PropTypes.string.isRequired
};

export default React.memo(NewsFeed);
